import { QueryObserverOptions, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { getRiskAssessmentInitialData } from './api';
import { RiskAssessmentDTO } from './dto/RiskAssessmentDTO';
import { QueryKey } from '@behavior/QueryKey';

type UseQueryOptionsKeys = Pick<QueryObserverOptions, 'enabled' | 'retry' | 'onSuccess'>;

export default function useRiskAssessmentInitialData(
  isCreationMode: boolean,
  options?: UseQueryOptionsKeys
) {
  const { t } = useTranslation();
  const { data: riskAssessmentInitial, isFetching } = useQuery<RiskAssessmentDTO>(
    [QueryKey.RISK_ASSESSMENT_INITIAL_DATA],
    () => getRiskAssessmentInitialData(isCreationMode),
    {
      enabled: true,
      onError: error => {
        toast.error(t('message.title.error.get.riskAssessment'));
      },
      ...options,
    }
  );
  return { riskAssessmentInitial: riskAssessmentInitial, isFetching, getRiskAssessmentInitialData };
}
